import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { environment } from '../../../../../environments/environment';
import { ReturnStruct } from '../../structs/return.struct';
import { ListaArquivoResponse } from '../../responses/integracao-arquivos/lista-arquivo.response';
import { ArquivoRequest } from '../../requests/integracao-arquivos/arquivo.request';
import { ArquivoUploadResponse } from '../../responses/integracao-arquivos/arquivo-upload.response';
import { ArquivoResponse } from '../../responses/integracao-arquivos/arquivo.response';

@Injectable({
  providedIn: 'root',
})
export class ArquivoService extends CommonService {
  constructor(
    private router: Router,
    private httpClient: HttpClient
  ) {
    super();
  }

  public obterListaArquivo(
    nome: string | null,
    versao: string | null,
    idCategoriaArquivo: number | null,
    paginaAtual: number
  ): Observable<ListaArquivoResponse> {
    let params = new HttpParams();

    if (nome) {
      params = params.set('nome', nome);
    }
    if (versao) {
      params = params.set('versao', versao);
    }
    if (idCategoriaArquivo) {
      params = params.set('idCategoriaArquivo', idCategoriaArquivo.toString());
    }

    return this.httpClient
      .get<ListaArquivoResponse>(
        environment.urlApiIntegracaoArquivos + `arquivo/listaarquivo/${paginaAtual}`,
        {
          headers: this.addHeaderToken().headers,
          params: params,
        }
      )
      .pipe(catchError(this.handleError));
  }

  public incluir(cadastroArquivoRequest: ArquivoRequest): Observable<ArquivoResponse> {
    return this.httpClient
      .post<ArquivoResponse>(
        environment.urlApiIntegracaoArquivos + `arquivo`,
        cadastroArquivoRequest,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }

  public uploadArquivo(idCategoriaArquivo: number, formData: FormData): Observable<ArquivoUploadResponse> {
    return this.httpClient
      .post<ArquivoUploadResponse>(
        environment.urlApiIntegracaoArquivos + `arquivo/upload/idCategoriaArquivo/${idCategoriaArquivo}`,
        formData,
        this.addHeaderFileToken()
      )
      .pipe(catchError(this.handleError));
  }

  public excluir(idArquivo: number): Observable<ReturnStruct> {
    return this.httpClient
      .delete<ReturnStruct>(
        environment.urlApiIntegracaoArquivos + `arquivo/idArquivo/${idArquivo}`,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }
}
